module.exports = __webpack_public_path__ + "static/media/lock_icon.0e0a49c1.svg";